import {EspApp, RegionView, syncModelWithSelectorOptions, useSyncModelWithSelector} from 'esp-js-react';
import {App} from 'esp-js-ui';
import * as React from 'react';
import {I18nextProvider} from 'react-i18next';

import {ShellContainerConsts} from '../../ioc';
import {LocaleService, SESSION_STORE_ID, SessionStoreModel, ThemeService} from '../../logic';
import {DecisionGateView} from '../gate/DecisionGateView';
import {PortalHeader} from './PortalHeader';
import {RegionNames} from './regionNames';

export interface AppShellViewProps {
    app: App;
}

// The decision gate is state-driven, not routed: whenever the session demands a pending decision
// the gate replaces whatever page the URL names, so no deep link can bypass it.
const GatedMain: React.FunctionComponent = () => {
    const session = useSyncModelWithSelector<SessionStoreModel, SessionStoreModel>(
        m => m,
        syncModelWithSelectorOptions<SessionStoreModel>().setStoreId(SESSION_STORE_ID)
    );
    return session.pendingGateChild !== null
        ? <DecisionGateView session={session}/>
        : <RegionView regionName={RegionNames.main}/>;
};

export const AppShellView: React.FunctionComponent<AppShellViewProps> = ({app}: AppShellViewProps) => {
    const themeService = app.container.resolve<ThemeService>(ShellContainerConsts.theme_service);
    const localeService = app.container.resolve<LocaleService>(ShellContainerConsts.locale_service);
    return (
        <EspApp app={app}>
            <I18nextProvider i18n={localeService.i18n}>
                <div role="app-root" className="min-h-screen bg-canvas font-ui text-text-primary">
                    <PortalHeader themeService={themeService}/>
                    <main>
                        <GatedMain/>
                    </main>
                </div>
            </I18nextProvider>
        </EspApp>
    );
};
